import React from 'react'
import styled from '@emotion/styled'
import Ajanlatkeres from '../containers/Ajanlatkeres'
import i00001 from '../images/burkolas/00001.jpg'
import i00002 from '../images/burkolas/00002.jpg'
import i00003 from '../images/burkolas/00003.jpg'
import i00004 from '../images/burkolas/00004.jpg'
import i00005 from '../images/burkolas/00005.jpg'
import i00006 from '../images/burkolas/00006.jpg'
import i00007 from '../images/burkolas/00007.jpg'
import i00008 from '../images/burkolas/00008.jpg'
import i00009 from '../images/burkolas/00009.jpg'
import i00010 from '../images/burkolas/00010.jpg'
import i00011 from '../images/burkolas/00011.jpg'
import i00012 from '../images/burkolas/00012.jpg'
import i00013 from '../images/burkolas/00013.jpg'
import i00014 from '../images/burkolas/00014.jpg'
import i00015 from '../images/burkolas/00015.jpg'
import i00016 from '../images/burkolas/00016.jpg'
import i00017 from '../images/burkolas/00017.jpg'
import i00018 from '../images/burkolas/00018.jpg'

const Main = styled.main`
  margin-top: 70px;
  line-height: 1.5rem;
`

const Title = styled.h2`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2.5rem;
  }
`

const SubTitle = styled.h3`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2rem;
  }
`

const Section = styled.section`
  position: relative;
  padding: 0 1rem;
  padding-bottom: 8px;
  margin: 2rem 0;

  a {
    text-decoration: none;
    color: initial;
  }

  ul {
    list-style: circle;

    li {
      margin: 0.5rem 0;

      a:after {
        content: ' ›';
      }
    }
  }

  &:first-of-type {
    margin-bottom: 4rem;
  }

  &:nth-of-type(2n) {
    background: linear-gradient(transparent 80px, rgba(39, 82, 54, 0.2) 80px, rgba(39, 82, 54, 0.2) 100%);

    ${SubTitle} {
      // color: #fff;
    }

    &:before {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      top: calc(80px - 2rem);
      width: 100%;
      height: 2rem;
      background: linear-gradient(to right top, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }

    &:after {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      bottom: -2rem;
      width: 100%;
      height: 2rem;
      background: linear-gradient(to left bottom, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }
  }

  @media (min-width: 64em) {
    p,
    ul,

    ${Title}, ${SubTitle} {
      margin: 2rem auto;
      max-width: 960px;
    }

    &:nth-of-type(2n) {
      &:before {
        top: calc(80px - 4rem);
        height: 4rem;
      }

      &:after {
        bottom: -4rem;
        height: 4rem;
      }
    }
  }
`

const Images = styled.section`
  overflow-y: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  height: 320px;
  margin: 0 -1rem;
  width: calc(100% + 2rem);
  display: flex;
  flex-direction: row;

  img {
    flex: 1;
    display: block;
    height: 100%;
  }

  img + img {
    margin-left: 5px;
  }

  @media (min-width: 64em) {
    overflow-x: auto;
    margin: 0 auto;
    max-width: 1540px;
    height: auto;
    flex-wrap: wrap;

    img {
      flex: 1;
      display: block;
      width: 30%;
      // height: auto;
      margin: 5px;
    }
  }
`

const ScrollIndicator = styled.span`
  text-align: center;
  width: 100%;
  display: block;
  font-size: 0.8rem;
  position: absolute;
  bottom: 0.5rem;
  left: 0;
  color: #fff;

  @media (min-width: 64em) {
    display: none;
  }
`

export default () => (
  <div>
    <Main>
      <Section>
        <SubTitle>Burkolás</SubTitle>
        <p>
          A különböző helyiségek kialakításánál manapság az egyre szélesedő termékválasztéknak köszönhetően, nem csak a
          praktikus szempontokat, hanem az esztétikai megfontolásokat is figyelembe kell vegyük. A rendkívül változékony
          méretű, színű és mintázatú csempék és padlóburkolatok a temérdek különböző szaniter, mind lehetőséget
          nyújtanak az egyéniségünkhöz legközelebb álló stílus megvalósításához. A lakásokban használt hidegburkolás és
          melegburkolás aránya a közelmúltban megváltozott. Az új fűtési rendszereknek, elsősorban a padlófűtésnek
          köszönhetően a hidegburkolatok aránya megnövekedett. Ma már nemcsak a klasszikusnak számító előszoba, WC,
          fürdőszoba és konyha kap hidegburkolást, hanem egyéb helyiségek is. A hidegburkolás nagy előnyének számít
          általában a könnyebb tisztíthatóság és a kopásállóság. Tért nyert a klipszes burkolás, mely a lapokat egyenlő
          fuga távolságban és síkban tartja. Fontos a helységnek megfelelő kopásállóságú lap megválasztása a színben
          hozzáillő fugaanyag és szilóplaszt kiválasztása. Kültérre fagyálló, nagy kopásállóságú lapot válasszunk.
        </p>
      </Section>
      <Section>
        <SubTitle>Parkettázás-Szőnyegezés</SubTitle>
        <p>
          Jellemzően a laminált parketták széles választéka az első számú burkoló anyag a szobákba, könnyen szabható,
          klikkes kialakítása miatt, egyszerűen szerelhető. Fontos az aljzat egyenessége, párazáró fóliázása,
          alátétlemezezése. Szegélyek felrakhatók rögzítőkre, ragasztva vagy szögelve. A parketta mellett a padlószőnyeg
          a második kedvelt burkolat típus nappalik, háló és gyerekszobák padlójának burkolására. Ezt érthető, hiszen
          puha felületről lévén szó, kellemesebb járást biztosít akár mezítláb is. Ugyanakkor gazdag szín és
          mintaválasztékú megoldás, melyben szinte biztosan mindenki megtalálja az ízlésének megfelelő terméket. Ha
          padlószőnyeget választ, biztos lehet benne, hogy kényelmes, barátságos belsőt biztosít otthonának, azon felül
          pedig nem gyűrődik fel, és nem csúszkál a hagyományos szőnyegekhez hasonlóan.
        </p>
      </Section>
      <Section>
        <SubTitle id="kepek">Képek</SubTitle>
        <Images>
          <img src={i00001} alt="" />
          <img src={i00002} alt="" />
          <img src={i00003} alt="" />
          <img src={i00004} alt="" />
          <img src={i00005} alt="" />
          <img src={i00006} alt="" />
          <img src={i00007} alt="" />
          <img src={i00008} alt="" />
          <img src={i00009} alt="" />
          <img src={i00010} alt="" />
          <img src={i00011} alt="" />
          <img src={i00012} alt="" />
          <img src={i00013} alt="" />
          <img src={i00014} alt="" />
          <img src={i00015} alt="" />
          <img src={i00016} alt="" />
          <img src={i00017} alt="" />
          <img src={i00018} alt="" />
        </Images>
        <ScrollIndicator>◀ ● ▶</ScrollIndicator>
      </Section>
      <Ajanlatkeres />
    </Main>
  </div>
)
